import React, { useContext, useEffect } from 'react';
import { Box } from '@mui/material';
import { ProjectContext } from 'context/ProjectContext';
import { Ecom } from 'types/types';

interface RunningCarbonTotalProps {
  latestEcomData: Ecom[];
}

const RunningCarbonTotal: React.FC<RunningCarbonTotalProps> = ({ latestEcomData }) => {
  const context = useContext(ProjectContext);
  if (!context) {
    throw new Error('ProjectContext error');
  }

  const { projectDetails, smqSubtotals, setSmqSubtotals } = context;

  const smqs = projectDetails.smqs || [];

  const calculateCarbonSubtotal = (overallStructure: 'Substructure' | 'Superstructure') => {
    return smqs
      .filter(field => field.field.overall_structure === overallStructure)
      .reduce((total, field) => {
        const quantity = parseFloat((field.quantity || 0).toString());
        const carbonFactor = latestEcomData['ECOMData']?.find(item => item?.material_type === field.material_type?.name)?.a1_a3_carbon_factor || 0;
        return total + (quantity * carbonFactor);
      }, 0);
  };

  useEffect(() => {
    const newSubstructureTotal = calculateCarbonSubtotal('Substructure');
    const newSuperstructureTotal = calculateCarbonSubtotal('Superstructure');

    setSmqSubtotals({
      Substructure: newSubstructureTotal,
      Superstructure: newSuperstructureTotal,
    });
  }, [smqs, latestEcomData, setSmqSubtotals]);

  const calculateTotalCarbon = smqSubtotals.Substructure + smqSubtotals.Superstructure;

  return (
    <Box sx={{ justifyContent: "flex-start", float: "right" }}>
      <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 700, height: 36 }}>
        <p style={{ marginRight: 24 }}>Running Total:</p>
        <p>{calculateTotalCarbon.toLocaleString()} kgCO2e</p>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", height: 36 }}>
        <p style={{ marginRight: 24 }}>Substructure Running Total:</p>
        <p>{smqSubtotals.Substructure.toLocaleString()} kgCO2e</p>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", height: 36 }}>
        <p style={{ marginRight: 24 }}>Superstructure Running Total:</p>
        <p>{smqSubtotals.Superstructure.toLocaleString()} kgCO2e</p>
      </div>
    </Box>
  );
};

export default RunningCarbonTotal;